export default __webpack_public_path__ + "static/media/2.c1386d05.png";